<template>
	<div class="card mb-0 shadow">
		<div class="card-body">
			<div class="tab-content">
				<div class="animate__animated animate__fadeIn">
					<Page titulo="Plano Individual de Atendimento - PIA" mode="table" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Page from "./Show.vue";
export default {
	components: { Page },
	props: ["item"],
};
</script>
<style scoped>
</style>
